import { graphql } from 'react-apollo';
import {
  pauseTimer,
  resumeTimer,
  triggerTimerVisibility,
} from '../queries/assignmentSession';
import { assignmentSubmitMutation } from '../queries/playerQueries';

export const withAssignmentSubmit = graphql(assignmentSubmitMutation, {
  props: ({ mutate }) => ({
    submitAssignment: (assignmentId) =>
      mutate({
        variables: {
          assignmentId,
        },
      }),
  }),
});

export const withPauseTimer = graphql(pauseTimer, { name: 'pauseTimer' });

export const withResumeTimer = graphql(resumeTimer, { name: 'resumeTimer' });

export const withTriggerTimerVisibility = graphql(triggerTimerVisibility, {
  name: 'triggerTimerVisibility',
});
